export default "__VITE_ASSET__Co0is2ky__"